module.exports = __webpack_public_path__ + "static/media/csrd_nav.5bc26b3d.svg";